// Column of the end-of-stay ratings a template question feeds; labels come from the backend
export enum EndOfJourneyColumnEnum {
  GENERAL = 'GENERAL',
  HF_WELCOME = 'HF_WELCOME',
  ACCOMMODATION = 'ACCOMMODATION',
  FOOD = 'FOOD',
  HF_FAMILY_LIFE = 'HF_FAMILY_LIFE',
  FOREIGN_TEACHER = 'FOREIGN_TEACHER',
  FRENCH_TEACHER = 'FRENCH_TEACHER',
  FRENCH_LEADER = 'FRENCH_LEADER',
  FOREIGN_LEADER = 'FOREIGN_LEADER',
  SPORTS_ACTIVITIES = 'SPORTS_ACTIVITIES',
  CAMP_ACTIVITIES = 'CAMP_ACTIVITIES',
  CULTURAL_ACTIVITIES = 'CULTURAL_ACTIVITIES',
  OPTION = 'OPTION',
  OTHER_ACTIVITIES = 'OTHER_ACTIVITIES',
  EVENINGS = 'EVENINGS',
  LANGUAGE_PROGRESS = 'LANGUAGE_PROGRESS',
  RECOMMEND = 'RECOMMEND',
  COME_BACK = 'COME_BACK',
  HF_TUITION = 'HF_TUITION'
}
